/* eslint-disable no-return-assign */
const axios = require('axios')
const StringBuffer = require('stringbuffer')

const mapboxToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN

// -----------------------------------------------------------------------------
// Build Mapbox forward geocoding URL
// -----------------------------------------------------------------------------
function buildMapboxGeocodingForwardUrl (addressText, addressOpts = {}) {
  // Build address input
  const searchText = encodeURIComponent(addressText)

  // Build Mapbox URL
  const url = new StringBuffer()
  url.append('https://api.mapbox.com/geocoding/v5/mapbox.places')
  url.append(`/${searchText}.json`)
  url.append(`?access_token=${mapboxToken}`)

  return url.toString()
}

// -----------------------------------------------------------------------------
// Extract coords from Mapbox geocoding results
// -----------------------------------------------------------------------------
function extractCoordsFromGeocodingResults (results = {}, opts = {}) {
  const locs = results.features || []
  const coords = {}

  const bestLoc = (locs && locs.length > 0) ? locs[0] : null
  if (bestLoc && bestLoc.center) {
    coords.longitude = bestLoc.center[0]
    coords.latitude = bestLoc.center[1]
  }

  return coords
}

// -----------------------------------------------------------------------------
// extractCoordsFromAddressData => { longitude, latitude }
//
// Extracts best match coordinates from address info
// -----------------------------------------------------------------------------
async function extractCoordsFromAddressData (data = {}) {
  const street1 = data.street_1 || ''
  const street = (data.street_2) ? `${street1}, ${data.street_2}` : street1
  const city = data.city || ''
  const state = data.state
  const region = (state) ? `${city}, ${state}` : city
  const zip = data.zip || ''
  const postalCode = data.postal_code || ''
  // const country = data.country || ''

  // Perform geocoding forward lookup (via Mapbox)
  const searchText = `${street}, ${region} ${zip} ${postalCode}`
  const mapboxUrl = buildMapboxGeocodingForwardUrl(searchText)

  const http = axios.create({ timeout: 30 * 1000 })
  let results = {}
  try {
    const response = await http.get(mapboxUrl)
    results = response.data
  } catch (err) {}

  // Extract coords from best match
  const coords = extractCoordsFromGeocodingResults(results)
  // console.log('[DEVING] extracted coords:', coords)
  return coords
}

// -----------------------------------------------------------------------------
// Build geojson format for route display layer
// -----------------------------------------------------------------------------
function generateGeoJson (routeData) {
  let geojson = null

  const tripData = (routeData.trips && routeData.trips.length > 0) ? routeData.trips[0] : null
  if (tripData) {
    const coordinates = (tripData.geometry) ? tripData.geometry.coordinates : null
    if (coordinates) {
      geojson = {
        type: 'FeatureCollection',
        features: [{
          type: 'Feature',
          geometry: { type: 'LineString', coordinates },
          properties: {}
        }]
      }
    }
  }

  return geojson
}

module.exports = {
  buildMapboxGeocodingForwardUrl,
  extractCoordsFromGeocodingResults,
  extractCoordsFromAddressData,
  generateGeoJson
}
